import { render, staticRenderFns } from "./order_data_statistics.vue?vue&type=template&id=70643c62&scoped=true"
import script from "./order_data_statistics.vue?vue&type=script&lang=js"
export * from "./order_data_statistics.vue?vue&type=script&lang=js"
import style0 from "./order_data_statistics.vue?vue&type=style&index=0&id=70643c62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70643c62",
  null
  
)

export default component.exports